<template>
  <div v-if="$route.name === 'top'" class="crpg-o-common-header__header">
    <div class="crpg-o-common-header__logo">
      <CMS
        contents_type="block_contents"
        location_code="CRPG_TOP_06_001-contents-logo"
      />
      <!-- /#logo -->
    </div>
    <!-- /#header -->
  </div>
</template>

<script>
import CMS from "@/components/CMS.vue";

export default {
  name: "MoleculesHeaderLogo",
  components: {
    CMS,
  },

};
</script>

<style lang="scss" scoped>
@import "@/assets/css/organisms/common/header.scss";
</style>
